import PropTypes from 'prop-types'

import {useState} from 'react'

import MediumModal from './mui_base_components/modals/medium_modal/MediumModal'

import {Privacy} from './Links'

import './funeralHomeClientPrivacyNoticeModal.scss'

const FuneralHomeClientPrivacyNoticeModal = ({
  linkText
}) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <div className='funeral-home-client-privacy-notice-modal'>
      <a onClick={() => setIsOpen(true)} role='button' tabIndex={0}>
        {linkText}
      </a>
      <MediumModal open={isOpen} onClose={() => setIsOpen(false)}>
        <h3 className='modal-title'>Privacy Notice</h3>
        <ol>
          <li>
            <h4 className='paragraph-title'>
              Funeral Home Partners (“FH Users”)
            </h4>
            <p className='paragraph'>
              If your Everplan is provided in connection with a participating funeral home, you acknowledge and agree that authorized representatives of that funeral home may access the information that is collected and populated in connection with your preneed arrangement, including but not limited to the Legacy Recording. This may include certain identifiers (such as name, contact information, date of birth, and Social Security number) and other details necessary to fulfill the services described in your preneed contract. They may also retain view access to these sections after your death for the purpose of coordinating arrangements and assisting your Deputies.
            </p>
            <p className='paragraph'>
              Funeral home representatives will not have access to any additional information you later choose to add directly to your Everplan.
            </p>
          </li>
          <li>
            <h4 className='paragraph-title'>
              Everplans Concierge (“Concierge”)
            </h4>
            <p className='paragraph'>
              The Concierge is a service that allows you to authorize a representative to assist you with parts or all of your Everplan. You may grant permission for them to view, edit, add, remove, and download the content from selected sections.
            </p>

            <p className='paragraph'>
              These permissions require explicit opt-in and can be revoked at any time through your account settings. All actions are logged for transparency, and you're responsible for any actions taken by someone you've granted access to.
            </p>
            <p className='paragraph'>
              In addition, to help you get started, an Everplans Concierge may enter the name and contact information of a Deputy you’ve identified. However, only you can send the actual invitation to that Deputy. This safeguard ensures that you always decide when and what to share. You’ll receive a notification any time a Concierge adds a Deputy, and you can review and send (or decline to send) the invitation before any information is shared.
            </p>
          </li>
        </ol>
        <p className='paragraph'>
          See the complete{' '}
          <Privacy target='_blank'>Everplans Privacy Policy</Privacy>.
        </p>
      </MediumModal>
    </div>
  )
}

FuneralHomeClientPrivacyNoticeModal.defaultProps = {
  linkText: 'Privacy notice'
}

FuneralHomeClientPrivacyNoticeModal.propTypes = {
  linkText: PropTypes.string
}

export default FuneralHomeClientPrivacyNoticeModal
